/**
 * UI-only helpers for Flight Status components.
 * API integration will use real data later.
 */

export function getBackgroundColor(colors) {
  if (!colors || !colors[0]) return {};
  return { backgroundColor: colors[0] };
}

export function getStrokeColor(bdrColor, isDefault = false) {
  let borderColor = {};
  if (Array.isArray(bdrColor) && bdrColor.length > 1) {
    borderColor = { borderColor: `${bdrColor[0]}` };
  } else if (bdrColor && bdrColor.length > 0) {
    borderColor = { borderColor: `${bdrColor}` };
  }
  if (isDefault) {
    return { border: `solid 1px ${borderColor.borderColor}` };
  }
  return borderColor;
}

/**
 * Replace density/type placeholders in icon URLs with actual density value.
 * Mirrors Flights-UI commonUtils replaceIcons.
 */
export function replaceIcons(url, density = "hdpi") {
  if (!url) return "";
  return url.replace("{type}", density).replace("%s", density).replace("{density}", density);
}

export function getBackgroundImage(image) {
  if (!image) return {};
  return { backgroundImage: `url(${image})` };
}
